module.exports = __webpack_public_path__ + "static/media/b-img-5.98aa04f0.png";